import React from "react";
import styled from "styled-components";
import {
  space,
  SpaceProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
} from "styled-system";
import { Box, Icon } from "@bca/ui-library";

interface ClickableImageProps extends SpaceProps, LayoutProps {
  imageURI: string;
  onClick: () => void;
}

const ImageOverlay = styled(Box)<PositionProps>`
  ${position}
  background-image: linear-gradient(transparent, transparent, #070b16);
`;

const Picture = styled.img<{ role: string; src: string; alt: string }>`
  border-radius: 8px;
  width: 100%;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
`;

const ExpandContainer = styled(Box)`
  display: none;
  background-color: white;
  border: none;
  border-radius: 25px;
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.26);
  width: 48px;
  height: 48px;
  margin: 0px;
  padding: 12px 0px 0px 12px;
  opacity: 0.6;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const ExpandIcon = styled(Icon)`
  opacity: 0.8;
  display: none;
`;

const ImageContainer = styled(Box)`
  position: relative;

  ${space};
  ${layout};

  &:hover {
    cursor: pointer;

    ${ExpandContainer} {
      display: block;
    }

    ${ExpandIcon} {
      display: block;
    }
  }
`;

const ClickableImage: React.FunctionComponent<ClickableImageProps> = ({
  imageURI,
  onClick,
  ...rest
}) => {
  return (
    <ImageContainer overflow="hidden" {...rest} onClick={onClick}>
      <Picture role="image" src={imageURI} alt="Image vehicle" />
      <ImageOverlay
        width="100%"
        height="100%"
        position="absolute"
        top={0}
        left={0}
        zIndex={1}
      ></ImageOverlay>
      <ExpandContainer display={["none", "block", "block"]}>
        <ExpandIcon
          name="expand-arrows"
          data-testid="svg-icon-container-expand-arrows"
          weight="regular"
          color="#444"
          width={24}
          height={24}
        />
      </ExpandContainer>
    </ImageContainer>
  );
};

export default ClickableImage;
